const appToken = '23bq86d10';
const scriptSource = `https://js.userpilot.io/${appToken}/latest.js`;
// scripts with IDs are added to `window`, so don't collide with the `window.userpilot` object
const scriptId = 'userpilot-js';

export function loadUserpilotScript(): void {
  if (document.querySelector(`script#${scriptId}`)) {
    return;
  }
  const script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = scriptSource;
  document.body.appendChild(script);
}
